/**
 * Kopf der öffentlichen Kundenseiten (Status-Link, Kunden-Link). Gehört die Anlage zu einem Betrieb, erscheinen
 * nur dessen Logo und Name, groß und fett (White Label) – AnmeldeMeister nur bei eigenen Kunden ohne Betrieb.
 * Bis die Daten da sind (und bei Fehlern), bleibt der Platz leer: kein kurzes Aufblitzen des falschen Logos.
 */
export function MarkenKopf({
  bereit,
  nurBetrieb,
  logo,
  name,
}: {
  bereit: boolean;
  nurBetrieb: boolean;
  logo: string | null | undefined;
  name: string | null | undefined;
}) {
  if (!bereit) return <div className="h-16" aria-hidden />;
  if (nurBetrieb) {
    return (
      <div className="flex min-h-16 flex-col items-start justify-center gap-2">
        {logo && <img src={logo} alt="" className="max-h-16 w-auto max-w-full" />}
        {name && <span className="text-xl font-bold leading-tight text-neutral-900 sm:text-2xl">{name}</span>}
      </div>
    );
  }
  return (
    <div className="flex h-16 items-center">
      <img src="/logo.png" alt="AnmeldeMeister" className="h-7 w-auto" />
    </div>
  );
}

/**
 * Impressum und Datenschutz unten auf den Kundenseiten. Bei Anlagen eines Betriebs die des Betriebs (er ist dort
 * Anbieter), sonst unsere. Solange unklar ist, zu wem die Seite gehört (Laden, Fehler), steht hier nichts.
 */
export function RechtsLinks({
  bereit,
  nurBetrieb,
  impressum,
  datenschutz,
}: {
  bereit: boolean;
  nurBetrieb: boolean;
  impressum?: string | null;
  datenschutz?: string | null;
}) {
  if (!bereit) return null;
  const links = nurBetrieb
    ? [
        ["Impressum", impressum],
        ["Datenschutz", datenschutz],
      ].filter((l): l is [string, string] => Boolean(l[1]))
    : [
        ["Impressum", "https://anmeldemeister.de/impressum.html"],
        ["Datenschutz", "https://anmeldemeister.de/datenschutz.html"],
      ];
  if (links.length === 0) return null;
  return (
    <p className="text-center text-xs text-neutral-400">
      {links.map(([text, href], i) => (
        <span key={text}>
          {i > 0 && " · "}
          <a className="underline" href={href} target="_blank" rel="noreferrer">{text}</a>
        </span>
      ))}
    </p>
  );
}
